const firebaseConfig = {
  apiKey: 'AIzaSyAA2sICahNgLZSGPyrokA9T01COB362h1M',
  authDomain: 'kids-world-42a68.firebaseapp.com',
  databaseURL: 'https://kids-world-42a68.firebaseio.com',
  projectId: 'kids-world-42a68',
  storageBucket: 'kids-world-42a68.appspot.com',
  messagingSenderId: '12383187502',
  appId: '1:12383187502:web:a4e69e54354a3d343b65bf',
  measurementId: 'G-Y64TZZ0YK4'
};

export { firebaseConfig };



// WEBPACK FOOTER //
// ./src/js/utils/firebase.js